import { render, staticRenderFns } from "./taskMgr.vue?vue&type=template&id=331e8d86&scoped=true&"
import script from "./taskMgr.vue?vue&type=script&lang=js&"
export * from "./taskMgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e8d86",
  null
  
)

export default component.exports